import { ID } from '@common/types';
import { createArrayFromObject } from '@common/utils/helpers/array/create-array-from-indexed-array';

export const getModelsId = <T extends { ID: ID }>(model?: Array<T> | T | null) => createArrayFromObject(model).map(({ ID }) => ID);
